/* SPECSBYLUX · Use Your Own Specs configurator
   Reads the two lens products' variants from #uy-data, maps each choice to the
   matching variant, and adds it to the cart with the order details as line
   properties. Tinted adds the "Sun · Tinted" line, paired with _pair. */
(function () {
  'use strict';
  var root = document.getElementById('uy-root');
  var dataEl = document.getElementById('uy-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) {
    root.innerHTML = '<p class="uy-noscript">Lens options could not load. Please call us and we will set up your order.</p>';
    return;
  }

  /* ---------- Color chart, darkness and recommendations (edit here) ---------- */
  var TINTS = {
    solid: [['Gray 1', '#7E9496'], ['Gray 3', '#5C6670'], ['Brown 1', '#B8874E'], ['Brown 3', '#9E7A4A'], ['Gray Green', '#4E7046'], ['Plum', '#6A2A55'], ['Gray Mist', '#7B8582'], ['Forest Gray', '#5F7258'], ['Sienna Brown', '#6E4A3C'], ['Grape', '#4B2F7E'], ['Ruby', '#8E3A3E'], ['Emerald Blue', '#2F6B66'], ['Copper', '#A95E2C']],
    gradient: [['Gray Mist', '#8E9393', '#E3E5E4'], ['Plum', '#8E5E7E', '#E8DCE6'], ['Forest Gray', '#8E978F', '#E4E7E3'], ['Sienna Brown', '#8C7A72', '#E6DFDB'], ['Grape', '#8D82B8', '#E3E0F0'], ['Emerald Blue', '#5F8A8C', '#DDE7E6']],
    mirror: [['Silver', '#6F8099', '#C9D3DF'], ['Gold', '#B8962A', '#EAD77A'], ['Blue', '#2E6DB5', '#7FB2E6'], ['Purple', '#4A3A86', '#8E7CC8']]
  };
  var POL = { grey: ['Grey', '#3B4146'], brown: ['Brown', '#6B4A33'], green: ['Green', '#3F4F3A'] };
  var ADAPT = { grey: ['Grey', '#2F3336'], brown: ['Brown', '#5B3A24'] };
  var DARK = { light: ['Light', '25%', 'Fashion and indoors. Not for bright sun.', '0.35'], medium: ['Medium', '50%', 'Everyday, overcast and city days.', '0.6'], dark: ['Dark', '80%', 'Full sun, beach and water.', '0.9'] };
  var USES = [
    { id: 'drive', label: 'Driving', set: { slens: 'pol', pcolor: 'grey' }, why: 'Polarized Grey keeps colors true and cuts glare off the road and windshields.' },
    { id: 'water', label: 'Beach and water', set: { slens: 'pol', pcolor: 'green' }, why: 'Polarized Green kills glare off water and sand and adds contrast in bright light.' },
    { id: 'city', label: 'Everyday in the city', set: { slens: 'tint', group: 'gradient', tint: 'Sienna Brown', dark: 'medium' }, why: 'A medium brown gradient: shade on top, clear view of your phone below.' },
    { id: 'style', label: 'Style, indoors and evenings', set: { slens: 'tint', group: 'solid', tint: 'Plum', dark: 'light' }, why: 'A light solid tint is all look. Keep it for indoors and low sun.' }
  ];
  var THIN_AT = 4.0, THINNEST_AT = 5.5;

  /* ---------- Variant names in Shopify (must match the products) ---------- */
  var EYE_VISION = { sv: 'Single Vision', prog: 'Progressive Lens' };
  var EYE_LENS = { clear: 'Premium', screen: 'Bluelight', adaptgrey: 'Photochromic Grey + Premium', adaptbrown: 'Photochromic Brown + Premium', adaptScreen: 'Photochromic Grey + Bluelight' };
  var EYE_MAT = ['Polycarbonate', 'Hi-index 1.67', 'Hi-index 1.74'];
  var SUN_VISION = { plano: 'Polarized Lenses', rdr: 'Polarized Lenses', sv: 'Single Vision Polarized Lenses', prog: 'SPECS-HD Progressive Polarized Lenses' };
  var SUN_MAT = ['Polycarbonate', '1.67 High Index Lenses'];

  var N = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
  var find = function (list, a, b, c) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (N(v.o1) === N(a) && N(v.o2) === N(b) && (c === undefined || N(v.o3) === N(c))) return v;
    }
    return null;
  };
  var strengthsOf = function (type) {
    var out = [], seen = {};
    (D[type] || []).forEach(function (v) {
      var s = type === 'eye' ? v.o1 : (N(v.o1) === N(SUN_VISION.rdr) ? v.o2 : '');
      if (/^\+\d/.test(s || '') && !seen[s]) { seen[s] = 1; out.push(s); }
    });
    return out.sort(function (x, y) { return parseFloat(x) - parseFloat(y); });
  };
  var STRENGTHS = { eye: strengthsOf('eye'), sun: strengthsOf('sun') };
  var TINT = D.tint && D.tint[0] ? D.tint[0] : null;

  /* ---------- Money ---------- */
  var formatMoney = function (cents) {
    var fmt = D.money || '${{amount}}';
    var withDelim = function (n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withDelim(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelim(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelim(cents, 0, '.', ',');
      return withDelim(cents, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  };
  var plus = function (c) { return c > 0 ? '+' + formatMoney(c) : 'Included'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  /* ---------- State ---------- */
  if (!D.kitTime) D.kitTime = '1–3 business days';
  var S = {
    step: 1, max: 1, type: D.start === 'sun' ? 'sun' : 'eye', frame: 'full', brand: '',
    vision: 'sv', strength: '+1.50', elens: 'clear', acolor: 'grey',
    slens: 'pol', pcolor: 'grey', group: 'gradient', tint: 'Sienna Brown', dark: 'medium', custom: '', help: false, use: '',
    method: 'enter', od: { sph: '0.00', cyl: '0.00', axis: '', add: '' }, os: { sph: '0.00', cyl: '0.00', axis: '', add: '' }, pd: '',
    mat: null, file: null, tried: 0, busy: false, cartErr: '', talk: false, ship: 'kit'
  };

  /* ---------- Pricing ---------- */
  var visionList = function () { return S.type === 'sun' ? ['plano', 'sv', 'prog', 'rdr'] : ['sv', 'prog', 'rdr']; };
  var hasRx = function () { return S.vision === 'sv' || S.vision === 'prog'; };
  var strengthNow = function () { var l = STRENGTHS[S.type]; return l.indexOf(S.strength) > -1 ? S.strength : (l[1] || l[0] || '+1.50'); };
  var eyeLensKey = function (l, col) { return l === 'adapt' ? 'adapt' + (col || S.acolor) : l; };
  var variantFor = function (type, vision, lens, mat) {
    if (type === 'eye') {
      var o1 = vision === 'rdr' ? strengthNow() : EYE_VISION[vision];
      return find(D.eye, o1, EYE_LENS[eyeLensKey(lens)], vision === 'rdr' ? EYE_MAT[0] : EYE_MAT[mat || 0]);
    }
    var o2 = vision === 'rdr' ? strengthNow() : (vision === 'plano' ? SUN_MAT[0] : SUN_MAT[mat || 0]);
    return find(D.sun, SUN_VISION[vision], o2);
  };
  var tintAdd = function (type, lens) { return type === 'sun' && lens === 'tint' && TINT ? TINT.p : 0; };
  var priceFor = function (type, vision, lens, mat) {
    var v = variantFor(type, vision, lens, mat);
    return v ? v.p + tintAdd(type, lens) : null;
  };
  var matCount = function () {
    if (!hasRx()) return 1;
    var n = 0, lens = S.type === 'sun' ? 'pol' : S.elens, names = S.type === 'sun' ? SUN_MAT : EYE_MAT;
    for (var i = 0; i < names.length; i++) { if (variantFor(S.type, S.vision, lens, i)) n = i + 1; else break; }
    return Math.max(n, 1);
  };
  var maxPower = function () {
    var vals = [S.od.sph, S.os.sph, S.od.cyl, S.os.cyl].map(function (v) { return Math.abs(parseFloat(v) || 0); });
    return Math.max.apply(null, vals);
  };
  var recMat = function () {
    if (!hasRx() || S.method !== 'enter') return 0;
    var m = maxPower(), n = matCount();
    if (m >= THINNEST_AT && n > 2) return 2;
    if (m >= THIN_AT && n > 1) return 1;
    return 0;
  };
  var matNow = function () {
    if (!hasRx()) return 0;
    if (S.mat === null) return S.max >= 4 ? recMat() : 0;
    return Math.min(S.mat, matCount() - 1);
  };
  var lensNow = function () { return S.type === 'sun' ? (S.slens === 'tint' && !TINT ? 'pol' : S.slens) : S.elens; };
  var baseLens = function () { return S.type === 'sun' ? 'pol' : 'clear'; };

  /* ---------- Steps ---------- */
  var stepList = function () { return hasRx() ? [1, 2, 3, 4, 5] : [1, 2, 3, 5]; };
  var stepNow = function () { var l = stepList(); return l.indexOf(S.step) > -1 ? S.step : 5; };
  var STEP_NAMES = { 1: 'Frame', 2: 'Vision', 3: 'Lenses', 4: 'Prescription', 5: 'Review' };
  var FRAME = { full: ['Full-rim', 'Lens fully enclosed'], semi: ['Semi-rimless', 'Rim on top, cord below'], rimless: ['Rimless / drilled', 'Lens screwed to frame'] };
  var VISION = { plano: 'Non-prescription', sv: 'Single vision', prog: 'Progressive', rdr: 'Readers' };
  var EYE_NAMES = { clear: 'Clear', screen: 'Screen', adapt: 'Light-adaptive', adaptScreen: 'Light-adaptive + Screen' };
  var MAT_NAMES = ['Standard 1.59', 'Thin 1.67', 'Thinnest 1.74'];
  var RX_NAMES = { enter: 'Typed in', upload: 'Uploaded photo', later: 'Sending it later' };
  var GROUPS = { solid: 'Solid', gradient: 'Gradient', mirror: 'Mirror', custom: 'Custom' };

  var curTint = function () {
    if (S.group === 'custom') return null;
    var list = TINTS[S.group];
    for (var i = 0; i < list.length; i++) if (list[i][0] === S.tint) return list[i];
    return list[0];
  };
  var colorName = function () {
    if (S.type !== 'sun') return S.elens === 'adapt' ? ADAPT[S.acolor][0] + ' outdoors' : (S.elens === 'adaptScreen' ? 'Grey outdoors' : '');
    if (lensNow() !== 'tint') return POL[S.pcolor][0] + ' polarized';
    if (S.group === 'custom') return 'Custom' + (S.custom.trim() ? ': ' + S.custom.trim() : ' shade');
    var t = curTint();
    return GROUPS[S.group] + ' ' + t[0] + (S.group !== 'mirror' ? ' · ' + DARK[S.dark][0] + ' ' + DARK[S.dark][1] : '');
  };
  var lensLabel = function () {
    var l = lensNow();
    if (S.type === 'sun') return l === 'tint' ? 'Tinted' : 'Polarized';
    return EYE_NAMES[l];
  };

  var rxProblems = function () {
    var p = {};
    if (S.method === 'enter') {
      ['od', 'os'].forEach(function (e) {
        var cyl = parseFloat(S[e].cyl) || 0;
        var ax = parseInt(S[e].axis, 10);
        if (cyl !== 0 && !(ax >= 1 && ax <= 180 && String(ax) === String(S[e].axis).trim())) p[e + 'axis'] = 1;
        if (S.vision === 'prog' && !S[e].add) p[e + 'add'] = 1;
      });
      if (!S.pd) p.pd = 1;
    }
    if (S.method === 'upload' && !S.file) p.file = 1;
    return p;
  };
  var blockedReason = function (step) {
    if (step === 3 && S.type === 'sun' && lensNow() === 'tint' && S.group === 'custom' && !S.custom.trim()) return 'Describe your custom color to continue.';
    if (step === 4) {
      var p = rxProblems();
      if (p.file) return 'Choose a photo or PDF of your prescription, or pick Send it later.';
      if (Object.keys(p).length) return 'Fill in the highlighted prescription fields.';
    }
    if (step === 5 && !variantFor(S.type, S.vision, lensNow(), matNow())) return 'This combination is not available. Call us and we will set it up.';
    return '';
  };

  /* ---------- Views ---------- */
  var IC = function (w, inner, stroke, sw) { return '<svg width="' + w + '" height="' + w + '" style="width:' + w + 'px;height:' + w + 'px;flex-shrink:0" viewBox="0 0 24 24" fill="none" stroke="' + (stroke || 'currentColor') + '" stroke-width="' + (sw || 1.8) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>'; };
  var ICON_CHECK = IC(14, '<path d="M5 12l4 4 10-10"></path>', '#FFFFFF', 2.6);
  var ICON_CHIP = IC(13, '<path d="M5 12l4 4 10-10"></path>', '#1A1A1A', 2.4);
  var ICON_INFO = IC(20, '<circle cx="12" cy="12" r="9"></circle><path d="M12 11v5"></path><path d="M12 8h.01"></path>');
  var ICON_SUN = IC(16, '<circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5"></path>');
  var ICON_HOME = IC(16, '<path d="M4 11l8-7 8 7"></path><path d="M6 10v10h12V10"></path>');
  var sid = root.getAttribute('data-section-id') || 'x';
  var gid = 'uyg-' + sid, cid = 'uyc-' + sid;

  /* ---------- Live preview: built once, then patched so colors fade instead of jumping ---------- */
  var previewModel = function () {
    var m = { t1: '#DDEFF6', t2: '#DDEFF6', gx: 0, op: 0.4, fx: 'ar', caption: 'Clear, anti-reflective', badge: 'Anti-reflective' };
    var l = lensNow();
    if (S.type === 'eye') {
      if (l === 'screen') { m.t1 = m.t2 = '#E8D9A0'; m.op = 0.3; m.fx = 'screen'; m.caption = 'Screen: filters blue light from screens'; m.badge = 'Blue light filtered'; }
      if (l === 'adapt' || l === 'adaptScreen') { m.t1 = m.t2 = ADAPT[l === 'adaptScreen' ? 'grey' : S.acolor][1]; m.op = 0.06; m.fx = l === 'adaptScreen' ? 'adapt screen' : 'adapt'; m.caption = ''; m.badge = 'Light-adaptive'; }
    } else if (l !== 'tint') {
      m.t1 = m.t2 = POL[S.pcolor][1]; m.op = 0.9; m.fx = 'pol'; m.caption = colorName(); m.badge = 'Glare blocked';
    } else if (S.group === 'custom') {
      m.t1 = '#B9AEA6'; m.t2 = '#E6E0DA'; m.op = 0.6; m.fx = 'tint'; m.caption = colorName(); m.badge = 'Custom tint';
    } else {
      var t = curTint();
      m.t1 = t[1]; m.t2 = t[2] || t[1]; m.gx = S.group === 'mirror' ? 1 : 0;
      m.op = S.group === 'mirror' ? 0.95 : parseFloat(DARK[S.dark][3]);
      m.fx = S.group === 'mirror' ? 'mirror' : 'tint'; m.caption = colorName();
      m.badge = S.group === 'mirror' ? 'Mirror' : (S.group === 'gradient' ? 'Gradient tint' : 'Solid tint');
    }
    if (m.caption.length > 44) m.caption = m.caption.slice(0, 43) + '…';
    return m;
  };

  var LENS_L = 'x="52" y="62" width="236" height="170" rx="64"', LENS_R = 'x="372" y="62" width="236" height="170" rx="64"';
  var frameShape = function () {
    if (S.frame === 'semi') return '<path d="M52 140 C52 92 80 62 130 62 L210 62 C260 62 288 92 288 140" fill="none" stroke="#1A1A1A" stroke-width="18"></path><path d="M372 140 C372 92 400 62 450 62 L530 62 C580 62 608 92 608 140" fill="none" stroke="#1A1A1A" stroke-width="18"></path><path d="M52 140 C52 200 80 232 130 232 L210 232 C260 232 288 200 288 140 M372 140 C372 200 400 232 450 232 L530 232 C580 232 608 200 608 140" fill="none" stroke="#9A9A96" stroke-width="2" stroke-dasharray="2 4"></path><path d="M288 112 C308 90 352 90 372 112" stroke="#1A1A1A" stroke-width="12" fill="none"></path><path d="M16 96 L52 86 M644 96 L608 86" stroke="#1A1A1A" stroke-width="10" stroke-linecap="round"></path>';
    if (S.frame === 'rimless') return '<rect ' + LENS_L + ' fill="none" stroke="#B8B8B4" stroke-width="2"></rect><rect ' + LENS_R + ' fill="none" stroke="#B8B8B4" stroke-width="2"></rect><path d="M276 104 C304 86 356 86 384 104" stroke="#8A8A86" stroke-width="5" fill="none" stroke-linecap="round"></path><path d="M20 92 L66 96 M640 92 L594 96" stroke="#8A8A86" stroke-width="5" stroke-linecap="round"></path><circle cx="68" cy="96" r="5" fill="#8A8A86"></circle><circle cx="592" cy="96" r="5" fill="#8A8A86"></circle><circle cx="278" cy="104" r="5" fill="#8A8A86"></circle><circle cx="382" cy="104" r="5" fill="#8A8A86"></circle>';
    return '<rect ' + LENS_L + ' fill="none" stroke="#1A1A1A" stroke-width="18"></rect><rect ' + LENS_R + ' fill="none" stroke="#1A1A1A" stroke-width="18"></rect><path d="M288 112 C308 90 352 90 372 112" stroke="#1A1A1A" stroke-width="14" fill="none"></path><path d="M16 96 L52 86 M644 96 L608 86" stroke="#1A1A1A" stroke-width="12" stroke-linecap="round"></path>';
  };

  var buildLeft = function () {
    var streaks = '';
    for (var i = 0; i < 6; i++) streaks += '<path class="uy-ray uy-ray--' + i + '" d="M' + (110 + i * 90) + ' 40 l-46 92" stroke="#3D7BFF" stroke-width="6" stroke-linecap="round" stroke-dasharray="14 18"></path>';
    var svg = '<svg class="uy-svg" viewBox="0 36 660 214" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Illustration of your frame with the lenses you choose">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1"><stop class="uy-stop" offset="0" style="stop-color:#DDEFF6"></stop><stop class="uy-stop" offset="1" style="stop-color:#DDEFF6"></stop></linearGradient>' +
      '<clipPath id="' + cid + '"><rect ' + LENS_L + '></rect><rect ' + LENS_R + '></rect></clipPath>' +
      '<linearGradient id="' + gid + 's" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#FFFFFF" stop-opacity="0"></stop><stop offset=".5" stop-color="#FFFFFF" stop-opacity=".95"></stop><stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop></linearGradient></defs>' +
      /* glare band passes behind the lenses: bright on the background, swallowed by a polarized lens */
      '<g class="uy-fx uy-fx--glare"><rect class="uy-glare" x="-200" y="40" width="160" height="210" fill="url(#' + gid + 's)" transform="skewX(-18)"></rect></g>' +
      '<rect class="uy-lens" ' + LENS_L + ' fill="url(#' + gid + ')" style="fill-opacity:.4"></rect><rect class="uy-lens" ' + LENS_R + ' fill="url(#' + gid + ')" style="fill-opacity:.4"></rect>' +
      '<g clip-path="url(#' + cid + ')">' +
        '<g class="uy-fx uy-fx--shimmer"><rect class="uy-shine" x="-200" y="40" width="110" height="210" fill="url(#' + gid + 's)" transform="skewX(-18)"></rect></g>' +
        '<g class="uy-fx uy-fx--screen">' + streaks + '</g>' +
      '</g>' +
      '<g class="uy-frame">' + frameShape() + '</g>' +
      '<path d="M92 200 L146 96 M412 200 L466 96" stroke="#FFFFFF" stroke-opacity=".55" stroke-width="10" stroke-linecap="round"></path>' +
      '</svg>';
    var thick = '<div class="uy-thick" aria-hidden="true"><svg viewBox="0 0 120 70" width="120" height="70" style="width:120px;height:70px"><g class="uy-thick__lens"><path d="M14 6 L42 6 Q30 35 42 64 L14 64 Q2 35 14 6 Z" fill="#DDEFF6" stroke="#1A1A1A" stroke-width="2"></path><path d="M78 6 L106 6 Q118 35 106 64 L78 64 Q90 35 78 6 Z" fill="#DDEFF6" stroke="#1A1A1A" stroke-width="2"></path></g></svg><span class="uy-thick__t"><span class="uy-thick__l">Lens edge</span><b class="uy-thick__v">Standard 1.59</b></span></div>';
    return '<div class="uy-left">' +
      '<div class="uy-crumb"><a href="/collections/use-your-own-specs">USE YOUR OWN SPECS</a> / <span data-p="crumb"></span></div>' +
      '<div class="uy-preview" data-p="box"><span class="uy-preview__tl">LIVE LENS PREVIEW</span><span class="uy-preview__tr" data-p="tag"></span>' +
      '<span class="uy-fxbadge" data-p="badge"></span>' +
      '<div class="uy-art">' + svg + '</div>' +
      '<div class="uy-adapt"><span class="uy-adapt__labels"><span class="uy-adapt__in">' + ICON_HOME + 'Indoors</span><span class="uy-adapt__out">' + ICON_SUN + 'Outdoors</span></span><span class="uy-adapt__bar"><span></span></span><span class="uy-adapt__note">Darkens in about 30 seconds outside</span></div>' +
      '<span class="uy-preview__bl" data-p="caption" data-live="caption"></span>' + thick +
      '<span class="uy-preview__br">Illustration · we fit lenses to your actual frame</span></div>' +
      '<div class="uy-trust"><span>Free shipping both ways</span><span>Optician-checked Rx</span><span>FSA / HSA accepted</span></div>' +
      '</div>';
  };

  var lastFrame = null;
  var paintLeft = function () {
    var wrap = document.getElementById('uy-leftwrap');
    if (!wrap.firstChild) wrap.innerHTML = buildLeft();
    var m = previewModel(), box = wrap.querySelector('[data-p="box"]');
    var q = function (k) { return wrap.querySelector('[data-p="' + k + '"]'); };
    q('crumb').textContent = S.type === 'sun' ? 'SUNGLASS LENSES' : 'EYEGLASS LENSES';
    q('tag').textContent = (S.type === 'sun' ? 'Sunglasses' : 'Eyeglasses') + ' · ' + FRAME[S.frame][0];
    q('badge').textContent = m.badge;
    q('caption').textContent = m.caption;
    if (lastFrame !== S.frame) { wrap.querySelector('.uy-frame').innerHTML = frameShape(); lastFrame = S.frame; }
    var stops = wrap.querySelectorAll('.uy-stop');
    stops[0].style.stopColor = m.t1; stops[1].style.stopColor = m.t2;
    wrap.querySelector('#' + gid).setAttribute('x2', String(m.gx));
    Array.prototype.forEach.call(wrap.querySelectorAll('.uy-lens'), function (r) { r.style.fillOpacity = String(m.op); r.classList.toggle('uy-lens--adapt', m.fx.indexOf('adapt') > -1); });
    box.className = 'uy-preview ' + m.fx.split(' ').map(function (f) { return 'uy-fx-' + f; }).join(' ') + (stepNow() === 4 && hasRx() ? ' uy-show-thick' : '');
    /* thickness inset: edges slim down as the index goes up */
    var mat = matNow(), scale = [1, 0.72, 0.55][mat] || 1;
    var tl = wrap.querySelector('.uy-thick__lens'); if (tl) tl.style.transform = 'scaleX(' + scale + ')';
    var tv = wrap.querySelector('.uy-thick__v'); if (tv) tv.textContent = MAT_NAMES[mat];
  };

  var stepper = function (step) {
    var list = stepList(), html = [];
    [1, 2, 3, 4, 5].forEach(function (n, i) {
      var skip = list.indexOf(n) === -1, cur = n === step, done = !skip && !cur && n < step;
      var reach = !skip && !cur && n <= S.max;
      var cls = 'uy-step' + (cur ? ' uy-step--cur' : '') + (done ? ' uy-step--done' : '') + (skip ? ' uy-step--skip' : '');
      if (i) html.push('<span class="uy-steps__sep" aria-hidden="true"></span>');
      html.push('<button type="button" class="' + cls + '" data-a="go" data-v="' + n + '" data-k="step' + n + '"' + (cur ? ' aria-current="step"' : '') + ' aria-disabled="' + (reach ? 'false' : 'true') + '">' +
        '<span class="uy-step__b">' + (done ? ICON_CHECK : (skip ? '–' : String(list.indexOf(n) + 1))) + '</span><span class="uy-step__l">' + (skip ? 'No Rx needed' : STEP_NAMES[n]) + '</span></button>');
    });
    return '<nav class="uy-steps" aria-label="Steps">' + html.join('') + '</nav>';
  };

  var summary = function (n) {
    if (n === 1) return (S.type === 'sun' ? 'Sunglasses' : 'Eyeglasses') + ' · ' + FRAME[S.frame][0];
    if (n === 2) return VISION[S.vision] + (S.vision === 'rdr' ? ' ' + strengthNow() : '');
    if (n === 3) {
      if (S.type === 'eye') return lensLabel() + (S.elens === 'adapt' ? ' · ' + ADAPT[S.acolor][0] : '');
      if (lensNow() !== 'tint') return 'Polarized · ' + POL[S.pcolor][0];
      return 'Tinted · ' + (S.group === 'custom' ? 'Custom' : GROUPS[S.group] + ' ' + curTint()[0]);
    }
    if (n === 4) return RX_NAMES[S.method] + ' · ' + MAT_NAMES[matNow()];
    return '';
  };

  var card = function (act, val, key, on, title, desc, price, tag) {
    return '<button type="button" class="uy-card" data-a="' + act + '" data-v="' + val + '" data-k="' + key + '" aria-pressed="' + on + '"><span class="uy-radio" aria-hidden="true"></span>' +
      '<span class="uy-card__t"><span class="uy-card__n">' + esc(title) + (tag ? '<span class="uy-tag">' + esc(tag) + '</span>' : '') + '</span><span class="uy-card__d">' + esc(desc) + '</span></span>' +
      '<span class="uy-card__p">' + esc(price) + '</span></button>';
  };
  var pill = function (act, val, key, on, label, dot) {
    return '<button type="button" class="uy-pill" data-a="' + act + '" data-v="' + val + '" data-k="' + key + '" aria-pressed="' + on + '">' + (dot ? '<span class="uy-dot" style="background:' + dot + '"></span>' : '') + esc(label) + '</button>';
  };

  var viewStep1 = function () {
    var minEye = priceFor('eye', 'sv', 'clear', 0), minSun = priceFor('sun', 'plano', 'pol', 0);
    var types = [['eye', 'Eyeglasses', 'Clear, Screen or light-adaptive lenses, cut to your prescription.', minEye], ['sun', 'Sunglasses', 'Polarized in grey, brown or green, or tinted any color on our chart.', minSun]];
    return '<div class="uy-panel"><h2>What are you sending us?</h2><p class="uy-intro">Any brand, any age. You keep your frame; we cut new lenses to fit it exactly.</p>' +
      '<div class="uy-tiles uy-tiles--2" role="group" aria-label="Frame type">' + types.map(function (t) {
        return '<button type="button" class="uy-tile uy-tile--big" data-a="type" data-v="' + t[0] + '" data-k="type-' + t[0] + '" aria-pressed="' + (S.type === t[0]) + '"><span class="uy-tile__row"><span class="uy-tile__n">' + t[1] + '</span>' +
          (t[3] != null ? '<span class="uy-tile__f">from <strong>' + formatMoney(t[3]) + '</strong></span>' : '') + '</span><span class="uy-tile__d">' + t[2] + '</span></button>';
      }).join('') + '</div>' +
      '<span class="uy-label">Frame style</span><div class="uy-tiles uy-tiles--3" role="group" aria-label="Frame style">' + Object.keys(FRAME).map(function (k) {
        return '<button type="button" class="uy-tile" data-a="frame" data-v="' + k + '" data-k="frame-' + k + '" aria-pressed="' + (S.frame === k) + '"><span class="uy-tile__n">' + FRAME[k][0] + '</span><span class="uy-tile__d">' + FRAME[k][1] + '</span></button>';
      }).join('') + '</div>' +
      (S.frame === 'rimless' ? '<div class="uy-note uy-note--warn" role="note">Rimless and drilled frames need a quick check first. Text a photo of your pair to <a href="sms:' + esc(D.phoneHref) + '">' + esc(D.phone) + '</a> and we\'ll confirm before you order.</div>' : '') +
      '<label class="uy-field">Frame brand and model <small>Optional · helps our lab prepare</small><input class="uy-input" type="text" data-in="brand" data-k="brand" maxlength="80" value="' + esc(S.brand) + '" placeholder="e.g. Ray-Ban RB5154 Clubmaster"></label></div>';
  };

  var viewStep2 = function () {
    var lens = baseLens();
    var desc = S.type === 'sun'
      ? { plano: 'Polarized or tinted sun lenses, no prescription.', sv: 'Your distance or reading prescription, in sun lenses.', prog: 'Near to far in one sun lens.', rdr: 'Magnification built into sun lenses.' }
      : { sv: 'One prescription for distance or for reading.', prog: 'No-line lenses: near, screen and far in one pair.', rdr: 'Magnification only. No prescription needed.' };
    var cards = visionList().filter(function (v) { return priceFor(S.type, v, lens, 0) != null; }).map(function (v) {
      return card('vision', v, 'vision-' + v, S.vision === v, VISION[v], desc[v], formatMoney(priceFor(S.type, v, lens, 0)), v === 'sv' ? 'MOST CHOSEN' : '');
    }).join('');
    var strengths = S.vision === 'rdr'
      ? '<span class="uy-label">Strength</span><div class="uy-pills" role="group" aria-label="Reader strength">' + STRENGTHS[S.type].map(function (s) { return pill('strength', s, 'str' + s, strengthNow() === s, s); }).join('') + '</div>'
      : '';
    return '<div class="uy-panel"><h2>What are these for?</h2><p class="uy-intro">Not sure? Look at your prescription. A number in the ADD column means Progressive is the right call.</p>' + cards + strengths +
      '<a href="sms:' + esc(D.phoneHref) + '" style="font-size:14px;font-weight:600;margin-top:6px">Need bifocals or something custom? Text an optician</a></div>';
  };

  var viewStep3 = function () {
    var out = '<div class="uy-panel"><h2>Choose your lenses</h2>';
    if (S.type === 'eye') {
      var base = priceFor('eye', S.vision, 'clear', 0);
      out += '<p class="uy-intro">Every pair is scratch-resistant with anti-reflective coating and 100% UV protection.</p>';
      [['clear', 'Premium anti-reflective. The everyday default.', ''], ['screen', 'Filters more blue light from screens and the sun.', 'DESK DAYS'], ['adapt', 'Clear indoors, tints on its own outside.', ''], ['adaptScreen', 'Both, in grey. One pair from laptop to sidewalk.', '']].forEach(function (o) {
        var p = priceFor('eye', S.vision, o[0], 0);
        if (p == null) return;
        out += card('elens', o[0], 'elens-' + o[0], S.elens === o[0], EYE_NAMES[o[0]], o[1], plus(p - base), o[2]);
      });
      if (S.elens === 'adapt') out += '<div class="uy-pills"><span class="uy-label" style="padding:0">Outdoor tint</span>' + ['grey', 'brown'].map(function (k) { return pill('acolor', k, 'acolor-' + k, S.acolor === k, ADAPT[k][0], ADAPT[k][1]); }).join('') + '</div>';
      return out + '</div>';
    }
    var lens = lensNow();
    out += '<p class="uy-intro">100% UV protection and scratch resistant, whatever you pick.</p>';
    out += '<div class="uy-help"><button type="button" class="uy-help__btn" data-a="help" data-k="help" aria-expanded="' + S.help + '"><span>' + ICON_INFO.replace('currentColor', '#00739F') + 'Not sure? Help me choose</span><span class="uy-help__sign" aria-hidden="true">' + (S.help ? '−' : '+') + '</span></button>';
    if (S.help) {
      var why = (USES.filter(function (u) { return u.id === S.use; })[0] || {}).why;
      out += '<div class="uy-help__body"><span style="font-size:13px;color:#5A5A5A">Where will you wear them most?</span><div class="uy-pills" role="group" aria-label="Where you\'ll wear them">' +
        USES.filter(function (u) { return TINT || u.set.slens !== 'tint'; }).map(function (u) { return '<button type="button" class="uy-use" data-a="use" data-v="' + u.id + '" data-k="use-' + u.id + '" aria-pressed="' + (S.use === u.id) + '">' + u.label + '</button>'; }).join('') + '</div>' +
        (why ? '<div class="uy-why" role="status"><strong>We picked it for you.</strong> ' + esc(why) + '</div>' : '') + '</div>';
    }
    out += '</div>';
    out += card('slens', 'pol', 'slens-pol', lens === 'pol', 'Polarized', 'Cuts glare off water, glass and pavement. Grey, brown or green.', 'Included', '');
    if (TINT) out += card('slens', 'tint', 'slens-tint', lens === 'tint', 'Tinted', 'Any color on our chart: solid, gradient or mirror, or a custom shade. Made as light or as dark as you like.', plus(TINT.p), 'NEW');
    out += '<div class="uy-color"><div><div class="uy-color__k">LENS COLOR</div><div class="uy-color__v" data-live="colorname">' + esc(colorName()) + '</div></div>';
    if (lens !== 'tint') {
      out += '<div class="uy-pills" role="group" aria-label="Polarized color">' + Object.keys(POL).map(function (k) { return pill('pcolor', k, 'pcolor-' + k, S.pcolor === k, POL[k][0], POL[k][1]); }).join('') + '</div><p class="uy-hint">Polarized lenses come in grey, brown or green.' + (TINT ? ' For other colors, choose Tinted.' : '') + '</p>';
    } else {
      out += '<div class="uy-pills" role="group" aria-label="Tint style">' + Object.keys(GROUPS).map(function (g) { return pill('group', g, 'group-' + g, S.group === g, GROUPS[g]); }).join('') + '</div>';
      if (S.group !== 'custom') {
        var cur = curTint();
        out += '<div class="uy-swatches" role="group" aria-label="Tint colors">' + TINTS[S.group].map(function (t) {
          var bg = t[2] ? 'linear-gradient(' + (S.group === 'mirror' ? '160deg' : '180deg') + ', ' + t[1] + ', ' + t[2] + ')' : t[1];
          return '<button type="button" class="uy-sw" data-a="tint" data-v="' + esc(t[0]) + '" data-k="tint-' + esc(t[0]) + '" aria-pressed="' + (cur[0] === t[0]) + '" aria-label="' + esc(t[0]) + '"><span class="uy-sw__dot" style="background:' + bg + '"></span>' + esc(t[0]) + '</button>';
        }).join('') + '</div>';
      }
      if (S.group === 'solid' || S.group === 'gradient') {
        out += '<div style="display:flex;flex-direction:column;gap:8px"><span style="font-size:13px;font-weight:600">How dark?</span><div class="uy-dark" role="group" aria-label="Tint darkness">' + Object.keys(DARK).map(function (d) {
          return '<button type="button" data-a="dark" data-v="' + d + '" data-k="dark-' + d + '" aria-pressed="' + (S.dark === d) + '"><b>' + DARK[d][0] + ' <span>' + DARK[d][1] + '</span></b><small>' + DARK[d][2] + '</small></button>';
        }).join('') + '</div><p class="uy-hint">Any tint can be made lighter or darker. Gradients fade from this darkness at the top to clear at the bottom.</p></div>';
      }
      if (S.group === 'mirror') out += '<p class="uy-hint">Mirror coatings sit over a dark grey base, made for full sun.</p>';
      if (S.group === 'custom') {
        var bad = S.tried >= 3 && !S.custom.trim();
        out += '<label class="uy-field" style="font-size:13px">Describe the color you want<input class="uy-input" type="text" data-in="custom" data-k="custom" maxlength="120" value="' + esc(S.custom) + '" placeholder="e.g. light rose gradient, or match a photo"' + (bad ? ' aria-invalid="true"' : '') + '></label><p class="uy-hint">We can tint almost any color. We\'ll confirm the shade with you by email before your lenses are cut.</p>';
      }
    }
    return out + '</div></div>';
  };

  var rxOptions = function (from, to, step, cur, zeroLabel, blank) {
    var html = blank ? '<option value=""' + (cur === '' ? ' selected' : '') + '>' + blank + '</option>' : '';
    var a = Math.round(from * 4), b = Math.round(to * 4), d = step > 0 ? 1 : -1;
    for (var q = a; d > 0 ? q <= b : q >= b; q += d) {
      var x = q / 4;
      var v = q === 0 ? '0.00' : (x > 0 ? '+' : '') + x.toFixed(2);
      html += '<option value="' + v + '"' + (v === cur ? ' selected' : '') + '>' + (v === '0.00' && zeroLabel ? zeroLabel : v) + '</option>';
    }
    return html;
  };
  var viewStep4 = function () {
    var p = S.tried >= 4 ? rxProblems() : {};
    var tabs = [['enter', 'Type it in'], ['upload', 'Upload a photo'], ['later', 'Send it later']].map(function (t) {
      return '<button type="button" role="tab" data-a="method" data-v="' + t[0] + '" data-k="method-' + t[0] + '" aria-selected="' + (S.method === t[0]) + '">' + t[1] + '</button>';
    }).join('');
    var out = '<div class="uy-panel"><h2>Add your prescription</h2><div class="uy-tabs" role="tablist" aria-label="How to add your prescription">' + tabs + '</div>';
    if (S.method === 'enter') {
      var prog = S.vision === 'prog';
      var row = function (e, name, code) {
        var r = S[e];
        return '<span class="uy-rx__eye"><b>' + name + '</b><small>' + code + '</small></span>' +
          '<select class="uy-select" aria-label="' + name + ' eye SPH" data-rx="' + e + '.sph" data-k="' + e + 'sph">' + rxOptions(-10, 6, 0.25, r.sph, '0.00 (plano)') + '</select>' +
          '<select class="uy-select" aria-label="' + name + ' eye CYL" data-rx="' + e + '.cyl" data-k="' + e + 'cyl">' + rxOptions(0, -4, -0.25, r.cyl) + '</select>' +
          '<input class="uy-input" aria-label="' + name + ' eye axis" inputmode="numeric" maxlength="3" data-rxin="' + e + '.axis" data-k="' + e + 'axis" value="' + esc(r.axis) + '" placeholder="' + ((parseFloat(r.cyl) || 0) !== 0 ? '1–180' : '—') + '"' + ((parseFloat(r.cyl) || 0) === 0 ? ' disabled' : '') + (p[e + 'axis'] ? ' aria-invalid="true"' : '') + '>' +
          (prog ? '<select class="uy-select" aria-label="' + name + ' eye ADD" data-rx="' + e + '.add" data-k="' + e + 'add"' + (p[e + 'add'] ? ' aria-invalid="true"' : '') + '>' + rxOptions(0.75, 3.5, 0.25, r.add, '', 'Select') + '</select>'
            : '<input class="uy-input" aria-label="' + name + ' eye ADD" disabled placeholder="—">');
      };
      var pdOpts = '<option value=""' + (S.pd === '' ? ' selected' : '') + '>Select</option>';
      for (var k = 50; k <= 76; k++) pdOpts += '<option value="' + k + '"' + (S.pd === String(k) ? ' selected' : '') + '>' + k + '</option>';
      pdOpts += '<option value="Not sure"' + (S.pd === 'Not sure' ? ' selected' : '') + '>Not sure, follow up with me</option>';
      out += '<div class="uy-rx" role="group" aria-label="Prescription values"><span></span><span class="uy-rx__h">SPH</span><span class="uy-rx__h">CYL</span><span class="uy-rx__h">AXIS</span><span class="uy-rx__h">ADD</span>' + row('od', 'Right', 'OD') + row('os', 'Left', 'OS') + '</div>';
      out += '<div class="uy-pd"><label for="uy-pd">Pupillary distance</label><select class="uy-select" id="uy-pd" data-rx="pd" data-k="pd"' + (p.pd ? ' aria-invalid="true"' : '') + '>' + pdOpts + '</select><a href="#uy-faq">Where do I find these?</a></div>';
      var rec = recMat();
      if (rec > 0) {
        var vals = [S.od.sph, S.os.sph, S.od.cyl, S.os.cyl], m = maxPower();
        var worst = vals.filter(function (v) { return Math.abs(parseFloat(v) || 0) === m; })[0];
        out += '<div class="uy-note uy-note--info" role="status">' + ICON_INFO + '<span><strong>At ' + esc(worst) + ', we recommend ' + MAT_NAMES[rec] + '.</strong> Thinner, lighter lenses that sit flush in your frame instead of bulging past the rim.</span></div>';
      }
    } else if (S.method === 'upload') {
      out += '<label class="uy-drop"' + (p.file ? ' style="border-color:#B3261E"' : '') + '><b>' + (S.file ? esc(S.file.name) : 'Drop a photo of your prescription') + '</b><span>' + (S.file ? 'Tap to choose a different file' : 'JPG, PNG, HEIC or PDF. Make sure the date and doctor\'s signature are visible.') + '</span>' +
        (S.file ? '' : '<em>Browse files</em>') + '<input type="file" accept="image/*,application/pdf" data-file="1" data-k="file" aria-label="Upload your prescription"></label>';
    } else {
      out += '<div class="uy-later"><b>Check out now, send it after</b><span>We\'ll email you a secure link to upload it or share your eye doctor\'s contact. Your lenses aren\'t cut until an optician has checked it.</span></div>';
    }
    var n = matCount(), mat = matNow(), recm = recMat(), base = priceFor(S.type, S.vision, lensNow(), 0);
    if (n > 1) {
      out += '<span class="uy-label">Lens thickness</span><div class="uy-tiles uy-tiles--' + (n === 3 ? '3' : '2') + '" role="group" aria-label="Lens thickness">';
      for (var i = 0; i < n; i++) {
        var pr = priceFor(S.type, S.vision, lensNow(), i);
        out += '<button type="button" class="uy-tile" data-a="mat" data-v="' + i + '" data-k="mat' + i + '" aria-pressed="' + (mat === i) + '"><span class="uy-tile__n">' + ['Standard', 'Thin', 'Thinnest'][i] + (recm === i && i > 0 ? '<span class="uy-tag">RECOMMENDED</span>' : '') + '</span><span class="uy-tile__d">' + MAT_NAMES[i].split(' ')[1] + ' · ' + plus(pr - base) + '</span></button>';
      }
      out += '</div>';
    }
    return out + '</div>';
  };

  var rxLine = function (e) {
    var r = S[e];
    var s = 'SPH ' + r.sph + ' · CYL ' + r.cyl;
    if ((parseFloat(r.cyl) || 0) !== 0) s += ' · AXIS ' + r.axis;
    if (S.vision === 'prog') s += ' · ADD ' + r.add;
    return s;
  };
  var viewStep5 = function () {
    var lens = lensNow(), mat = matNow();
    var vBase = priceFor(S.type, S.vision, baseLens(), 0);
    var lensAdd = priceFor(S.type, S.vision, lens, 0) - vBase;
    var total = priceFor(S.type, S.vision, lens, mat);
    var matAdd = total - priceFor(S.type, S.vision, lens, 0);
    var rows = [
      ['YOUR FRAME', (S.type === 'sun' ? 'Your sunglasses' : 'Your eyeglasses') + ' · ' + FRAME[S.frame][0], S.brand || 'Brand and model not given', '', 1],
      ['VISION', VISION[S.vision] + (S.vision === 'rdr' ? ' ' + strengthNow() : ''), S.type === 'sun' ? 'Sun lenses · 100% UV' : 'Anti-reflective · scratch-resistant · 100% UV', formatMoney(vBase), 2],
      ['LENSES', lensLabel(), colorName(), plus(lensAdd), 3]
    ];
    if (hasRx()) {
      rows.push(['THICKNESS', MAT_NAMES[mat], recMat() === mat && mat > 0 ? 'Recommended for your prescription' : '', plus(matAdd), 4]);
      rows.push(['PRESCRIPTION', RX_NAMES[S.method], S.method === 'enter' ? 'OD ' + rxLine('od') + ' / OS ' + rxLine('os') + ' · PD ' + S.pd : (S.method === 'upload' && S.file ? S.file.name : ''), '', 4]);
    }
    var prog = S.vision === 'prog';
    return '<div class="uy-panel" style="gap:0"><h2 style="margin-bottom:8px">Review your lenses</h2>' + rows.map(function (r) {
      return '<div class="uy-review__row"><span class="uy-review__k">' + r[0] + '</span><span class="uy-review__v">' + esc(r[1]) + (r[2] ? '<small>' + esc(r[2]) + '</small>' : '') + '</span><span class="uy-review__p">' + esc(r[3]) + '</span><button type="button" class="uy-review__e" data-a="go" data-v="' + r[4] + '" data-k="edit' + r[0] + '">Edit</button></div>';
    }).join('') +
      '<div class="uy-shipin" role="group" aria-labelledby="uy-shipin-h"><b id="uy-shipin-h">How will you send us your frames?</b>' +
      card('ship', 'kit', 'ship-kit', S.ship === 'kit', 'Mail me a shipping kit', 'Everything you need to pack your pair, with a prepaid label, at your door in ' + D.kitTime + '. Best for valuable or fragile frames.', 'Free', 'MOST PROTECTED') +
      card('ship', 'label', 'ship-label', S.ship === 'label', 'Email me a prepaid label', 'Print it today and pack your pair in any padded mailer or box.', 'Free', 'FASTEST') + '</div>' +
      '<div class="uy-after"><b>What happens after checkout</b><div class="uy-ship" aria-hidden="true"><span class="uy-ship__end">' + ICON_HOME + 'You</span><span class="uy-ship__track"><span class="uy-ship__box"></span></span><span class="uy-ship__end">Our lab</span></div><ol>' +
      (S.ship === 'kit' ? '<li><span>' + esc(D.kitTime) + '</span>Shipping kit arrives at your door</li>' : '<li><span>Today</span>Prepaid label in your inbox</li>') +
      '<li><span>1–3 days</span>Your frames reach our lab</li><li><span>' + esc(prog ? D.labTimeProg : D.labTime) + '</span>' + (prog ? 'Progressives surfaced to order' : (lens === 'tint' ? 'Lenses tinted and cut' : 'Lenses cut and fitted')) + '</li><li><span>1–3 days</span>Back to your door, free</li></ol></div>' +
      '<p class="uy-hint" style="font-size:14px;margin-top:12px">' + esc(D.reviewNote) + '</p></div>';
  };

  var fromPrice = function (type) {
    var best = null;
    (type === 'sun' ? ['plano', 'sv', 'prog', 'rdr'] : ['sv', 'prog', 'rdr']).forEach(function (v) { var p = priceFor(type, v, type === 'sun' ? 'pol' : 'clear', 0); if (p != null && (best === null || p < best)) best = p; });
    return best;
  };
  var footModel = function () {
    var step = stepNow(), total = priceFor(S.type, S.vision, lensNow(), matNow());
    var isFrom = S.max < 2;
    if (isFrom) total = fromPrice(S.type);
    var labels = { 1: 'Continue to vision', 2: 'Continue to lenses', 3: hasRx() ? 'Continue to prescription' : 'Review order', 4: 'Review order', 5: 'Add to cart · ' + (total != null ? formatMoney(total) : '') };
    var reason = blockedReason(step);
    return { step: step, total: total, isFrom: isFrom, label: S.busy ? 'Adding…' : labels[step], reason: reason, showReason: !!reason && S.tried >= step };
  };
  var viewFoot = function () {
    var f = footModel(), list = stepList(), pos = list.indexOf(f.step);
    return '<div class="uy-foot"><div class="uy-total"><span class="uy-total__k" data-live="totalk">' + (f.isFrom ? 'FROM' : 'TOTAL') + '</span><span class="uy-total__v" data-live="total">' + (f.total != null ? formatMoney(f.total) : '—') + '</span>' +
      '<span class="uy-total__s" data-live="quarter">' + (f.total != null ? (f.isFrom ? 'Your total updates as you choose · ' : '') + 'or 4 interest-free payments of ' + formatMoney(Math.round(f.total / 4)) + ' with Afterpay' : '') + '</span></div>' +
      '<div class="uy-nav">' + (pos > 0 ? '<button type="button" class="uy-back" data-a="back" data-k="back">Back</button>' : '') +
      '<button type="button" class="uy-next" data-a="next" data-k="next" aria-disabled="' + (!!f.reason) + '"' + (S.busy ? ' aria-busy="true"' : '') + ' data-live="next">' + esc(f.label) + '</button></div></div>' +
      '<p class="uy-error" role="status" data-live="reason"' + (f.showReason || S.cartErr ? '' : ' hidden') + '>' + esc(S.cartErr || f.reason) + '</p>';
  };

  var viewTalk = function () {
    if (D.talk === false) return '';
    var ph = esc(D.phoneHref || ''), num = esc(D.phone || '');
    return '<div class="uy-talk">' + (S.talk ? '<div class="uy-talk__card" role="dialog" aria-label="Talk to a human"><b>Talk To A Human</b><span>Questions about your frame or prescription? A real optician will help.</span>' +
      '<a class="uy-talk__call" href="tel:' + ph + '">Call ' + num + '</a><a class="uy-talk__text" href="sms:' + ph + '">Text us a photo</a></div>' : '') +
      '<button type="button" class="uy-talk__btn" data-a="talk" data-k="talk" aria-label="' + (S.talk ? 'Close' : 'Talk to a human') + '" aria-expanded="' + S.talk + '">' + IC(20, '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"></path>', '#FFFFFF', 1.9) + '<span class="uy-talk__lbl">' + (S.talk ? 'Close' : 'Talk To A Human') + '</span></button></div>';
  };

  /* Hide the call bubble while the Continue / Add to cart bar is on screen, so it never covers it */
  var footVisible = false, io = null;
  var applyTalk = function () { var t = root.querySelector('.uy-talk'); if (t) t.classList.toggle('uy-talk--hide', footVisible && !S.talk); };
  var watchFoot = function () {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (es) { footVisible = es[0].isIntersecting; applyTalk(); }, { rootMargin: '0px 0px -10px 0px' });
    var f = root.querySelector('.uy-foot'); if (f) io.observe(f);
    applyTalk();
  };

  var render = function () {
    var active = document.activeElement, key = active && root.contains(active) ? active.getAttribute('data-k') : null;
    if (!document.getElementById('uy-leftwrap')) root.innerHTML = '<div class="uy-grid"><div id="uy-leftwrap"></div><div class="uy-main" id="uy-main"></div></div><div id="uy-talkwrap"></div>';
    var step = stepNow();
    var chips = stepList().filter(function (n) { return n < step && n < 5; }).map(function (n) {
      return '<button type="button" class="uy-chip" data-a="go" data-v="' + n + '" data-k="chip' + n + '">' + ICON_CHIP + '<span>' + esc(summary(n)) + '</span><em>Change</em></button>';
    }).join('');
    var body = { 1: viewStep1, 2: viewStep2, 3: viewStep3, 4: viewStep4, 5: viewStep5 }[step]();
    var from = fromPrice(S.type);
    document.getElementById('uy-main').innerHTML = '<div class="uy-head"><div><h1>New lenses for your frames</h1><div class="uy-head__sub">Use Your Own Specs · eyeglasses or sunglasses · any brand</div></div>' +
      (from != null ? '<div class="uy-head__from">from <strong>' + formatMoney(from) + '</strong></div>' : '') + '</div>' +
      stepper(step) + (chips ? '<div class="uy-chips">' + chips + '</div>' : '') + '<div class="uy-anim" key="' + step + '">' + body + '</div>' + viewFoot();
    if (lastStep !== step) { var an = root.querySelector('.uy-anim'); if (an) { an.classList.add('uy-anim--in'); } lastStep = step; }
    document.getElementById('uy-talkwrap').innerHTML = viewTalk();
    paintLeft();
    watchFoot();
    if (key) { var el = root.querySelector('[data-k="' + key.replace(/"/g, '\\"') + '"]'); if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
  };
  var lastStep = 0;

  var refreshLive = function () {
    var f = footModel();
    var set = function (sel, txt) { var el = root.querySelector('[data-live="' + sel + '"]'); if (el) el.textContent = txt; return el; };
    set('colorname', colorName());
    paintLeft();
    var nb = set('next', f.label); if (nb) nb.setAttribute('aria-disabled', String(!!f.reason));
    var rs = root.querySelector('[data-live="reason"]'); if (rs) { rs.textContent = S.cartErr || f.reason; rs.hidden = !(f.showReason || S.cartErr); }
    var ci = root.querySelector('[data-in="custom"]'); if (ci && S.custom.trim()) ci.removeAttribute('aria-invalid');
    var probs = rxProblems();
    Array.prototype.forEach.call(root.querySelectorAll('[data-rxin]'), function (el) { if (!probs[el.getAttribute('data-rxin').replace('.', '')]) el.removeAttribute('aria-invalid'); });
  };

  var goTo = function (n) {
    S.step = n; S.max = Math.max(S.max, n); S.cartErr = '';
    render();
    var main = document.getElementById('uy-main');
    if (main && main.getBoundingClientRect().top < 0) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ---------- Cart ---------- */
  var buildProps = function () {
    var p = {};
    p['Frame'] = (S.type === 'sun' ? 'Sunglasses' : 'Eyeglasses') + ' · ' + FRAME[S.frame][0];
    if (S.brand.trim()) p['Frame brand / model'] = S.brand.trim();
    var isCustom = S.type === 'sun' && lensNow() === 'tint' && S.group === 'custom';
    p['Lenses'] = lensLabel() + (isCustom ? ' · Custom color' : (colorName() ? ' · ' + colorName() : ''));
    if (isCustom) p['Custom color'] = S.custom.trim() + ' (confirm shade by email)';
    if (hasRx()) {
      p['Lens thickness'] = MAT_NAMES[matNow()];
      p['Prescription'] = RX_NAMES[S.method];
      if (S.method === 'enter') { p['Right eye (OD)'] = rxLine('od'); p['Left eye (OS)'] = rxLine('os'); p['PD'] = S.pd; }
    }
    if (S.vision === 'rdr') p['Reader strength'] = strengthNow();
    p['Ship-in kit'] = S.ship === 'kit' ? 'Shipping kit by mail' : 'Prepaid label by email';
    return p;
  };
  var addToCart = function () {
    var v = variantFor(S.type, S.vision, lensNow(), matNow());
    if (!v) return;
    var tint = S.type === 'sun' && lensNow() === 'tint' ? TINT : null;
    var pair = tint ? 'uy' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) : '';
    var props = buildProps();
    var fd = new FormData();
    fd.append('id', v.id); fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
    if (pair) fd.append('properties[_pair]', pair);
    if (hasRx() && S.method === 'upload' && S.file) fd.append('properties[Prescription file]', S.file);
    S.busy = true; S.cartErr = ''; render();
    var fail = function (msg) { S.busy = false; S.cartErr = msg || 'Something went wrong adding to cart. Please try again or call ' + D.phone + '.'; render(); };
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
      .then(function () {
        if (!tint) return null;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: tint.id, quantity: 1, properties: { _pair: pair, 'For': 'Use Your Own Specs' } }] }) })
          .then(function (r) { if (!r.ok) throw new Error('Tint line'); });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) { fail(e && e.message && e.message !== 'Tint line' ? e.message : ''); });
  };

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-a]');
    if (!t || !root.contains(t) || S.busy) return;
    var a = t.getAttribute('data-a'), v = t.getAttribute('data-v');
    var step = stepNow(), list = stepList();
    switch (a) {
      case 'go': if (t.getAttribute('aria-disabled') === 'true') return; goTo(parseInt(v, 10)); return;
      case 'back': goTo(list[list.indexOf(step) - 1]); return;
      case 'next':
        S.tried = Math.max(S.tried, step);
        if (blockedReason(step)) { render(); return; }
        if (step === 5) { addToCart(); return; }
        goTo(list[list.indexOf(step) + 1]); return;
      case 'type': S.type = v; S.mat = null; if (visionList().indexOf(S.vision) === -1) S.vision = 'sv'; break;
      case 'frame': S.frame = v; break;
      case 'vision': S.vision = v; S.mat = null; break;
      case 'strength': S.strength = v; break;
      case 'elens': S.elens = v; break;
      case 'acolor': S.acolor = v; break;
      case 'slens': S.slens = v; S.use = ''; break;
      case 'pcolor': S.pcolor = v; S.use = ''; break;
      case 'group': S.group = v; S.tint = v === 'custom' ? '' : TINTS[v][0][0]; S.use = ''; break;
      case 'tint': S.tint = v; S.use = ''; break;
      case 'dark': S.dark = v; S.use = ''; break;
      case 'help': S.help = !S.help; break;
      case 'talk': S.talk = !S.talk; break;
      case 'use': var u = USES.filter(function (x) { return x.id === v; })[0]; if (u) { Object.keys(u.set).forEach(function (k) { S[k] = u.set[k]; }); S.use = v; } break;
      case 'method': S.method = v; S.mat = null; break;
      case 'mat': S.mat = parseInt(v, 10); break;
      case 'ship': S.ship = v === 'label' ? 'label' : 'kit'; break;
      default: return;
    }
    render();
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-rx')) {
      var path = t.getAttribute('data-rx').split('.');
      if (path.length === 2) { S[path[0]][path[1]] = t.value; if (path[1] === 'cyl' && (parseFloat(t.value) || 0) === 0) S[path[0]].axis = ''; }
      else S[path[0]] = t.value;
      if (path[1] === 'sph' || path[1] === 'cyl') S.mat = null;
      render();
    } else if (t.hasAttribute('data-file')) {
      S.file = t.files && t.files[0] ? t.files[0] : null;
      render();
    }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-in')) { S[t.getAttribute('data-in')] = t.value; refreshLive(); }
    else if (t.hasAttribute('data-rxin')) { var p = t.getAttribute('data-rxin').split('.'); S[p[0]][p[1]] = t.value.replace(/[^\d]/g, ''); if (t.value !== S[p[0]][p[1]]) t.value = S[p[0]][p[1]]; refreshLive(); }
  });

  render();
})();